import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Response } from "@angular/http";
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { User, Register, Login, Office, Search } from './user.model';

@Injectable()
export class UserService {
     // readonly rootUrl = 'http://localhost:14058';
    readonly rootUrl = 'http://bmtfapi.esdinfra.com';

  httpOptions: any;

  constructor(private http: HttpClient) {
    let accesstoken = localStorage.getItem('accessToken');
    if (accesstoken != null && accesstoken != '' && typeof (accesstoken) != undefined) {
      this.httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + accesstoken,
          'No-Auth': 'True'
        })
      };
    }
  }

  getAllowedPages() {
    let accesstoken = localStorage.getItem('accessToken');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + accesstoken
      })
    };
    return this.http.get(this.rootUrl + '/api/AllowedPages', this.httpOptions);
  }

  getAllRoles(itemsPerPage: number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Roles/GetAll/' + itemsPerPage+"/"+pageNo, this.httpOptions);
  }

  getAllUsers(itemsPerPage: number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Users/GetAll/' + itemsPerPage+"/"+pageNo, this.httpOptions);
  }
  getAllClaimsForTheRole(roleId: string) {
    return this.http.get(this.rootUrl + '/api/Claims/' + roleId, this.httpOptions);
  }
  getRoleForTheId(roleId: string) {
    return this.http.get(this.rootUrl + '/api/Roles/' + roleId, this.httpOptions);
  }

  getUserForTheId(Id: string) {
    return this.http.get(this.rootUrl + '/api/Users/' + Id, this.httpOptions);
  }
  
  getOfficeForTheId(OfficeId: string) {
       return this.http.get(this.rootUrl + '/api/Offices/' + OfficeId, this.httpOptions);
  }

  getAllClaims(itemsPerPage: number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Roles/GetAll/' + itemsPerPage+"/"+pageNo, this.httpOptions);
  }

  GetAllRoleNames() {
    return this.http.get(this.rootUrl + '/api/Roles/GetAllOffices/', this.httpOptions);
  }

  getAllDistrictName() {
    debugger;
    return this.http.get(this.rootUrl + '/api/Users/GetAllDistrict', this.httpOptions);
  }

  // getRolesforSelectedOffice(officeId) {
  //   return this.http.get(this.rootUrl + '/api/Roles/getRolesforSelectedOffice/' + officeId, this.httpOptions);
  // }
  getRolesforSelectedOffice() {

    return this.http.get(this.rootUrl + '/api/Roles/getRolesforSelectedOffice', this.httpOptions);
  }

  GetAllOffices(itemsPerPage:number,pageNo:number) {
    return this.http.get(this.rootUrl + '/api/Offices/GetAll/' +itemsPerPage+"/"+pageNo, this.httpOptions);
  }


  registerUser(register: Register) {
  
    return this.http.post(this.rootUrl + '/api/Account/Register', register, this.httpOptions);
  }

  registerCustomer(register: Register) {
  
    return this.http.post(this.rootUrl + '/api/CustomerAccount/Register', register, this.httpOptions);
  }

  createRole(user: User) {
    return this.http.post(this.rootUrl + '/api/Roles/Create', user, this.httpOptions);
  }

  updateRole(user: User,roleId:string) {
    return this.http.put(this.rootUrl + '/api/Roles/Update/'+roleId, user, this.httpOptions);
  }

  searchRoles(searchCriteria:any,searchText:any,itemsPerPage:number,pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Roles/Search/'+searchCriteria+"/"+searchText+"/"+itemsPerPage+"/"+pageNo, this.httpOptions);
  }  

  searchUsers(searchCriteria:any,searchText:any,itemsPerPage:number,pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Users/Search/'+searchCriteria+"/"+searchText+"/"+itemsPerPage+"/"+pageNo, this.httpOptions);
  }  

  searchOffices(searchCriteria:any,searchText:any, itemsPerPage:number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Offices/Search/'+searchCriteria+"/"+searchText+"/"+itemsPerPage+"/"+pageNo, this.httpOptions);
  }  
  updateOffice(office: Office,OfficeId:string) {
       return this.http.put(this.rootUrl + '/api/Offices/Update/'+OfficeId, office, this.httpOptions);
  }

  saveClaims(claimsList, roleId) {
    return this.http.put(this.rootUrl + '/api/Claims/' + roleId + '/assignClaims', claimsList, this.httpOptions);
  }

  CreateOffice(office: Office) {
    return this.http.post(this.rootUrl + '/api/Offices/Create', office, this.httpOptions);
  }

  changePassword(userDetails:any){
    return this.http.post(this.rootUrl + '/api/Account/ChangePassword', userDetails, this.httpOptions);
  }
  
  changePasswordForTheId(userDetails:any){
    return this.http.put(this.rootUrl + '/api/Account/Update', userDetails, this.httpOptions);
  }

  deleteRole(id: string){
    return this.http.put(this.rootUrl + '/api/Roles/Delete/'+id, this.httpOptions);
  }

  activateInactivateUser(id: string){
    return this.http.put(this.rootUrl + '/api/Users/ActivateInactivate/'+id, null, this.httpOptions);
  }
  
  activateInactivateRoles(id: string){
    return this.http.put(this.rootUrl + '/api/Roles/ActivateInactivate/'+id, null, this.httpOptions);
  }

  activateInactivateOffices(id: string){
    return this.http.put(this.rootUrl + '/api/Offices/ActivateInactivate/'+id, null, this.httpOptions);
  }



  //sarita masters BMTF
// ComplaintType
  GetComplaintTypeDetails(itemsPerPage:any,pageNo:any) {
    return this.http.get(this.rootUrl + '/api/ComplaintTypeDetails/GetAllComplaintType/'+itemsPerPage+"/"+pageNo, this.httpOptions);
  
  }
  DeleteComplaintType(cmplnt_id) {
    return this.http.delete(this.rootUrl + '/api/ComplaintTypeDetails/DeleteComplaintType/' + cmplnt_id, this.httpOptions);
  }  
  
  SearchComplaintType(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/ComplaintTypeDetails/GetAllComplaintTypeBySearch/' + itemsPerPage + "/" + pageNo + "/" + searchCriteria + "/" + searchText + "/",this.httpOptions);
  }
  GetComplaintTypeById(cmplnt_id) {
    return this.http.get(this.rootUrl + '/api/ComplaintTypeDetails/GetByIdComplaintType/' +cmplnt_id , this.httpOptions);
  }
  PostComplaintType(udm) {
    return this.http.post(this.rootUrl + '/api/ComplaintTypeDetails/CreateComplaintType', udm, this.httpOptions);
  }
  
  UpdateComplaintType(udm,cmplnt_id) {
    return this.http.put(this.rootUrl + '/api/ComplaintTypeDetails/UpdateComplaintType/'+cmplnt_id, udm, this.httpOptions);
  }
  
//Enactments


GetEnactmentsDetails(itemsPerPage:any,pageNo:any) {
  return this.http.get(this.rootUrl + '/api/EnactmentsDetails/GetAllEnactments/'+itemsPerPage+"/"+pageNo, this.httpOptions);

}
DeleteEnactments(Enactment_id) {
  return this.http.delete(this.rootUrl + '/api/EnactmentsDetails/DeleteEnactments/' + Enactment_id, this.httpOptions);
}
SearchEnactments(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
  return this.http.get(this.rootUrl + '/api/EnactmentsDetails/GetAllEnactmentsBySearch/' + itemsPerPage + "/" + pageNo + "/" + searchCriteria + "/" + searchText + "/",this.httpOptions);
}
GetEnactmentById(Enactment_id) {
  return this.http.get(this.rootUrl + '/api/EnactmentsDetails/GetByIdEnactments/' +Enactment_id , this.httpOptions);
}
PostEnactments(udm) {
  return this.http.post(this.rootUrl + '/api/EnactmentsDetails/CreateEnactments', udm, this.httpOptions);
}
UpdateEnactments(udm,Enactment_id) {
  return this.http.put(this.rootUrl + '/api/EnactmentsDetails/UpdateEnactments/'+Enactment_id, udm, this.httpOptions);
}

//jurisdiction

GetJurisdictionDetails(itemsPerPage:any,pageNo:any) {
  return this.http.get(this.rootUrl + '/api/JurisdictionDetails/GetAllJurisdiction/'+itemsPerPage+"/"+pageNo, this.httpOptions);

}
DeleteJurisdiction(Jurt_id) {
  return this.http.delete(this.rootUrl + '/api/JurisdictionDetails/DeleteJurisdiction/' + Jurt_id, this.httpOptions);
}
SearchJurisdiction(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
  return this.http.get(this.rootUrl + '/api/JurisdictionDetails/GetAllJurisdictionBySearch/' + itemsPerPage + "/" + pageNo + "/" + searchCriteria + "/" + searchText + "/",this.httpOptions);
}
GetJurisdictionById(Jurt_id) {
  return this.http.get(this.rootUrl + '/api/JurisdictionDetails/GetByIdJurisdiction/' +Jurt_id , this.httpOptions);
}
PostJurisdiction(udm) {
  return this.http.post(this.rootUrl + '/api/JurisdictionDetails/CreateJurisdiction', udm, this.httpOptions);
}
UpdateJurisdiction(udm,Jurt_id) {
  return this.http.put(this.rootUrl + '/api/JurisdictionDetails/UpdateJurisdiction/'+Jurt_id, udm, this.httpOptions);
}


//office

GetMOfficeDetails(itemsPerPage:any,pageNo:any) {
  return this.http.get(this.rootUrl + '/api/MOfficeDetails/GetAllMOffice/'+itemsPerPage+"/"+pageNo, this.httpOptions);

}
DeleteMOffice(Office_id) {
  return this.http.delete(this.rootUrl + '/api/MOfficeDetails/DeleteMOffice/' + Office_id, this.httpOptions);
}
SearchMOffice(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
  return this.http.get(this.rootUrl + '/api/MOfficeDetails/GetAllMOfficeBySearch/' + itemsPerPage + "/" + pageNo + "/" + searchCriteria + "/" + searchText + "/",this.httpOptions);
}
GetMOfficeById(Office_id) {
  return this.http.get(this.rootUrl + '/api/MOfficeDetails/GetByIdMOffice/' +Office_id , this.httpOptions);
}
PostMOffice(udm) {
  return this.http.post(this.rootUrl + '/api/MOfficeDetails/CreateMOffice', udm, this.httpOptions);
}
UpdateMOffice(udm,Office_id) {
  return this.http.put(this.rootUrl + '/api/MOfficeDetails/UpdateMOffice/'+Office_id, udm, this.httpOptions);
}


//DEpartment


GetDepartmentDetails(itemsPerPage:any,pageNo:any) {
  return this.http.get(this.rootUrl + '/api/DepartmentDetails/GetAllDepartment/'+itemsPerPage+"/"+pageNo, this.httpOptions);

}
DeleteDepartment(Jurt_id) {
  return this.http.delete(this.rootUrl + '/api/DepartmentDetails/DeleteDepartment/' + Jurt_id, this.httpOptions);
}

SearchDepartment(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
  return this.http.get(this.rootUrl + '/api/DepartmentDetails/GetAllDepartmentBySearch/' + itemsPerPage + "/" + pageNo + "/" + searchCriteria + "/" + searchText + "/",this.httpOptions);
}

GetDepartmentById(Jurt_id) {
  return this.http.get(this.rootUrl + '/api/DepartmentDetails/GetByIdDepartment/' +Jurt_id , this.httpOptions);
}
PostDepartment(udm) {
  return this.http.post(this.rootUrl + '/api/DepartmentDetails/CreateDepartment', udm, this.httpOptions);
}

UpdateDepartment(udm,Jurt_id) {
  return this.http.put(this.rootUrl + '/api/DepartmentDetails/UpdateDepartment/'+Jurt_id, udm, this.httpOptions);
}




//
  userAuthentication(user: Login) {
    var data = "username=" + user.UserName + "&password=" + user.Password + "&grant_type=password";
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' })
    }
    return this.http.post(this.rootUrl + '/token', data, httpOptions);
  }
  ////Complaint GET
  
  GetComplaintDetails(itemsPerPage:any,pageNo:any) {
    return this.http.get(this.rootUrl + '/api/ComplaintDetails/GetAllComplaint/'+itemsPerPage+"/"+pageNo, this.httpOptions);
  
  }
//Search omplaint
SearchComplaint(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
  return this.http.get(this.rootUrl + '/api/ComplaintDetails/GetAllComplaintBySearch/' + itemsPerPage + "/" + pageNo + "/" + searchCriteria + "/" + searchText + "/",this.httpOptions);
}

// get compliant tyope details in complaint
GetAllComplaintType() {
  return this.http.get(this.rootUrl + '/api/ComplaintDetails/GetComplaintType', this.httpOptions);
}
PostComplaint(udm) {
  return this.http.post(this.rootUrl + '/api/ComplaintDetails/CreateComplaint', udm, this.httpOptions);
}
uploadImage(data) {
  return this.http.post(this.rootUrl + '/api/ComplaintDetails/image', data);
}
GetByIdComplaint(Comp_id) {
  return this.http.get(this.rootUrl + '/api/ComplaintDetails/GetByIdComplaint/' +Comp_id , this.httpOptions);
}
UpdateComplaint(udm,Comp_id) {
  return this.http.put(this.rootUrl + '/api/ComplaintDetails/UpdateComplaint/'+Comp_id, udm, this.httpOptions);
}
DeleteComplaint(Comp_id) {
  return this.http.delete(this.rootUrl + '/api/ComplaintDetails/DeleteComplaint/' + Comp_id, this.httpOptions);
}
//office ddl
GetAllOffice1() {
  return this.http.get(this.rootUrl + '/api/ComplaintDetails/GetOffice', this.httpOptions);
}
uploadImage3(data) {
  return this.http.post(this.rootUrl + '/api/ComplaintDetails/image3', data);
}
//Fir Module

GetFirDetails(itemsPerPage:any,pageNo:any) {
  return this.http.get(this.rootUrl + '/api/FirDetails/GetAllFir/'+itemsPerPage+"/"+pageNo, this.httpOptions);

}
SearchFir(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
  return this.http.get(this.rootUrl + '/api/FirDetails/GetAllFirBySearch/' + '/' + "/" + itemsPerPage + "/" + pageNo + "/" + searchCriteria + "/" + searchText + "/",this.httpOptions);
}

SearchFirdetails(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
  return this.http.get(this.rootUrl + '/api/FirDetails/GetAllFirBySearch/' + itemsPerPage + "/" + pageNo + "/" + searchCriteria + "/" + searchText + "/",this.httpOptions);
}

PostFir(udm) {
  return this.http.post(this.rootUrl + '/api/FirDetails/CreateFir', udm, this.httpOptions);
}



//getting offc ddl

GetAllOffice() {
  return this.http.get(this.rootUrl + '/api/FirDetails/GetOffice', this.httpOptions);
}
//get district ddl

GetAllDistrict() {
  return this.http.get(this.rootUrl + '/api/FirDetails/GetDistrict', this.httpOptions);
}

//get complainttype ddl
 GetAllComplaintT() {
  return this.http.get(this.rootUrl + '/api/FirDetails/GetComplaintType', this.httpOptions);
}
GetAllComplaintNo() {
  return this.http.get(this.rootUrl + '/api/FirDetails/GetComplaintNo', this.httpOptions);
}


//get state ddl
GetAllState() {
  return this.http.get(this.rootUrl + '/api/FirDetails/GetState', this.httpOptions);
}
//get all enactment ddl 
GetAllEnactment() {
  return this.http.get(this.rootUrl + '/api/FirDetails/GetEnactment', this.httpOptions);
}
GetByIdFir(Fir_id) {
  return this.http.get(this.rootUrl + '/api/FirDetails/GetByIdFir/' +Fir_id , this.httpOptions);
}


UpdateFir(udm,Fir_id) {
  return this.http.put(this.rootUrl + '/api/FirDetails/UpdateFir/'+Fir_id, udm, this.httpOptions);
}
DeleteFir(Fir_id) {
  return this.http.delete(this.rootUrl + '/api/FirDetails/DeleteFir/' + Fir_id, this.httpOptions);
}

//upload
uploadImage1(data) {
  return this.http.post(this.rootUrl + '/api/FirDetails/image1', data);
}
uploadImage2(data) {
  return this.http.post(this.rootUrl + '/api/FirDetails/image1', data);
}

//Proceeding details

GetAllFirPagination(itemsPerPage: number, PageNo: number) {
  return this.http.get(this.rootUrl + '/api/FirDetails/GetAllFir/' + itemsPerPage + '/' + PageNo, this.httpOptions);
}
GetFirProceedingetails(Fir_id) {
  return this.http.get(this.rootUrl + '/api/ProceedingDetails/GetFirDetailsForProceedings/' + Fir_id, this.httpOptions);

}

PostProceeding(udm) {
  return this.http.post(this.rootUrl + '/api/ProceedingDetails/CreateProceedings', udm, this.httpOptions);
}
uploadImage5(data) {
  return this.http.post(this.rootUrl + '/api/ProceedingDetails/image5', data);
}

GetAllProceedingDetails(itemsPerPage:any,pageNo:any,Fir_id) {
  debugger;
  return this.http.get(this.rootUrl + '/api/ProceedingDetails/GetAllProceedings/' +itemsPerPage+"/" +pageNo+"/"+ Fir_id ,this.httpOptions);

}
// GetProceedingOnSearch(Fir_id, NextHearingDate, value) {
//   return this.http.get(this.rootUrl + '/api/ProceedingDetails/GetAllProceedingsOnserach/' + Fir_id + '/' + NextHearingDate + '/' + value, this.httpOptions);

// }
GetProceedingOnSearch(Fir_id: any,searchBy: any, searchValue: any, ItemsPerPage: number, pageno: number) {
  return this.http.get(this.rootUrl + '/api/ProceedingDetails/GetAllProceedingsOnserach/' + Fir_id + "/" + ItemsPerPage + "/" + pageno + "/" + searchBy + "/" + searchValue + "/",this.httpOptions);
}

DeleteProcById(Proc_Id) {
  return this.http.delete(this.rootUrl + '/api/ProceedingDetails/DeleteProceeding/' + Proc_Id, this.httpOptions);
}

calculateAge(dateOfBirth) {

  return this.http.get(this.rootUrl + '/api/ComplaintDetails/calculateAge/' + dateOfBirth, this.httpOptions);
}


//investigation
GetFirInvestigationetails(Comp_id) {
  return this.http.get(this.rootUrl + '/api/InvestigationDetails/GetFirInvestigationetails/' + Comp_id, this.httpOptions);

}


PostInvestigation(udm) {
  return this.http.post(this.rootUrl + '/api/InvestigationDetails/CreateInvestigationDoc', udm, this.httpOptions);
}
GetAllInvestigationDetails(itemsPerPage:any,pageNo:any,Fir_id) {
  debugger;
  return this.http.get(this.rootUrl + '/api/InvestigationDetails/GetAllInvestigation/' +itemsPerPage+"/" +pageNo+"/"+ Fir_id ,this.httpOptions);

}
DeleteInvestigationById(InvDoc_Id) {
  return this.http.delete(this.rootUrl + '/api/InvestigationDetails/DeleteInvestigation/' + InvDoc_Id, this.httpOptions);
}
GetInvestigationOnSearch(Fir_id: any,searchBy: any, searchValue: any, ItemsPerPage: number, pageno: number) {
  return this.http.get(this.rootUrl + '/api/InvestigationDetails/GetAllInvestigationDocOnserach/' + Fir_id + "/" + ItemsPerPage + "/" + pageno + "/" + searchBy + "/" + searchValue + "/",this.httpOptions);
}
uploadImage6(data) {
  return this.http.post(this.rootUrl + '/api/InvestigationDetails/image6', data);
}
GetAllFirPaginations(itemsPerPage: number, PageNo: number) {
  return this.http.get(this.rootUrl + '/api/FirDetails/GetAllFir/' + itemsPerPage + '/' + PageNo, this.httpOptions);
}


UpdateFile(udm, InvDoc_Id :any) {
  return this.http.post(this.rootUrl + '/api/InvestigationDetails/Updatefile' +'/'+InvDoc_Id, udm, this.httpOptions);
}


GetInvestigationById(InvDoc_Id) {
  debugger;
  return this.http.get(this.rootUrl + '/api/InvestigationDetails/GetByIdInvestigation/' +InvDoc_Id , this.httpOptions);
}
GetAllDepartment() {
  return this.http.get(this.rootUrl + '/api/InvestigationDetails/GetDepartment', this.httpOptions);
}
GetDeptDoc(dep_Id) {
  return this.http.get(this.rootUrl + '/api/InvestigationDetails/GetDeptDoc/' + dep_Id, this.httpOptions);

}
//DepartmentDocument

GetAllDepartmentPagination(itemsPerPage: number, PageNo: number) {
  return this.http.get(this.rootUrl + '/api/DepartmentDetails/GetAllDepartment/' + itemsPerPage + '/' + PageNo, this.httpOptions);
}

SearchDepartmentsdetails(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
  return this.http.get(this.rootUrl + '/api/DepartmentDetails/GetAllDepartmentBySearch/' + itemsPerPage + "/" + pageNo + "/" + searchCriteria + "/" + searchText + "/",this.httpOptions);
}
GetDepartmentGridDetails(dep_Id) {
  return this.http.get(this.rootUrl + '/api/DepartmentDocumentDetails/GetDepartmentGridDetails/' + dep_Id, this.httpOptions);

}
PostDepartmentDocument(udm) {
  return this.http.post(this.rootUrl + '/api/DepartmentDocumentDetails/CreateDepartmentDocument', udm, this.httpOptions);
}
GetAllDepartmentDocumentDetails(itemsPerPage:any,pageNo:any,dep_Id) {
  debugger;
  return this.http.get(this.rootUrl + '/api/DepartmentDocumentDetails/GetAllDepartmentDocument/' +itemsPerPage+"/" +pageNo+"/"+ dep_Id ,this.httpOptions);

}
GetDepartmentDocumentOnSearch(dep_Id: any,searchBy: any, searchValue: any, ItemsPerPage: number, pageno: number) {
  return this.http.get(this.rootUrl + '/api/DepartmentDocumentDetails/GetAllDepartmentDocumentOnserach/' + dep_Id + "/" + ItemsPerPage + "/" + pageno + "/" + searchBy + "/" + searchValue + "/",this.httpOptions);
}
DeleteDepartmentDocumentById(DeptDoc_Id) {
  return this.http.delete(this.rootUrl + '/api/DepartmentDocumentDetails/DeleteDepartmentDocument/' + DeptDoc_Id, this.httpOptions);
}


//Primililary enquiry


// GetCompalintDetails(Comp_id) {
//   debugger;
//   return this.http.get(this.rootUrl + '/api/PrEnqDetails/GetCompDetailsPrEnq/' + Comp_id, this.httpOptions);

// }
GetCompalintDetails(Comp_id) {
  return this.http.get(this.rootUrl + '/api/PrEnqDetails/GetCompDetailsPrEnq/' + Comp_id, this.httpOptions);

}

GetComplaintType(Comp_id) {
  return this.http.get(this.rootUrl + '/api/PrEnqDetails/GetComplaintType/' + Comp_id, this.httpOptions);

}

GetAccused(Comp_id) {
  return this.http.get(this.rootUrl + '/api/PrEnqDetails/GetAccused/' + Comp_id, this.httpOptions);

}
GetAlldOcumentlist() { 

 return this.http.get(this.rootUrl + '/api/PrEnqDetails/GetDocList', this.httpOptions);

}
uploadImageENq(data) {
  return this.http.post(this.rootUrl + '/api/PrEnqDetails/image1', data);
}
PostPrimilaryEnq(udm) {
  return this.http.post(this.rootUrl + '/api/PrEnqDetails/CreatePrEnq', udm, this.httpOptions);
}
DeleteEnqPr(PrEnq_Id) {
  return this.http.delete(this.rootUrl + '/api/PrEnqDetails/DeletePrEnq/' + PrEnq_Id, this.httpOptions);
}


//Case Dairy
GetAllFirDetails(itemsPerPage: number, pageNo: number) {
  return this.http.get(this.rootUrl + '/Api/CaseDiary/GetAllFirDetails/' + itemsPerPage + "/" + pageNo+ "/", this.httpOptions);
}

SearchFirDetails(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
  return this.http.get(this.rootUrl + '/Api/CaseDiary/Search/' + searchCriteria + "/" + searchText + "/" + itemsPerPage + "/" + pageNo+ "/", this.httpOptions);
}

GetFirForTheId(Fir_id: any) {
  return this.http.get(this.rootUrl + '/api/CaseDiary/' + Fir_id, this.httpOptions);
}
CreateCaseDiary(Fir_id,CaseDiary) {
  return this.http.post(this.rootUrl + '/api/CaseDiary/CreateCaseDiary/'+Fir_id, CaseDiary, this.httpOptions);
}

DeleteCaseDiary(CD_Id) {
  return this.http.put(this.rootUrl + '/api/CaseDiary/DeleteCaseDiary/' + CD_Id, null, this.httpOptions);
}

//CourtProceeding
GetAllFirDetailsCp(itemsPerPage: number, pageNo: number) {
  return this.http.get(this.rootUrl + '/Api/Courtproc/GetAllFirDetailsCp/' + itemsPerPage + "/" + pageNo+ "/", this.httpOptions);
}

SearchFirDetailsCp(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
  return this.http.get(this.rootUrl + '/Api/Courtproc/SearchCp/' + searchCriteria + "/" + searchText + "/" + itemsPerPage + "/" + pageNo+ "/", this.httpOptions);
}
GetFirForTheIdCp(Fir_id: any) {
  return this.http.get(this.rootUrl + '/api/Courtproc/' + Fir_id, this.httpOptions);
}
// (udm,Court_Proc_Id) {
//   return this.http.post(this.rootUrl + '/api/Courtproc/CreateCourtProceedingDoc/'+ Court_Proc_Id, udm, this.httpOptions);
// }

PostCourtDoc(Court_Proc_Id,CourtDoc) {
  return this.http.post(this.rootUrl + '/api/Courtproc/CreateCourtProceedingDoc/'+Court_Proc_Id, CourtDoc, this.httpOptions);
}
UpdateCourtProceeding(udm,Court_Proc_Id) {
  return this.http.put(this.rootUrl + '/api/Courtproc/UpdateCourtProceeding/'+Court_Proc_Id, udm, this.httpOptions);
}
GetByIdCourtDoc(Court_Proc_Id) {
  return this.http.get(this.rootUrl + '/api/Courtproc/GetByIdFir/' +Court_Proc_Id , this.httpOptions);
}
DeleteCourtDoc(CourtProc_Doc_Id) {
  return this.http.delete(this.rootUrl + '/api/Courtproc/DeleteCourtDoc/' + CourtProc_Doc_Id, this.httpOptions);
}
GetInvestigationForTheId(Fir_id: any) {
  return this.http.get(this.rootUrl + '/Api/Investigation/' + Fir_id, this.httpOptions);
}

CreateAccusedStatement(InvDoc_Id, Investigation) {
  return this.http.post(this.rootUrl + '/api/Investigation/CreateAccusedStatement/' + InvDoc_Id, Investigation, this.httpOptions);
}
GetAccusedStatemant(InvDoc_Id: any) {
  return this.http.get(this.rootUrl + '/api/Investigation/GetAccusedStatemant/' + InvDoc_Id, this.httpOptions);
}
DeleteAccusedStatemant(Id) {
  return this.http.put(this.rootUrl + '/api/Investigation/DeleteAccusedStatemant/' + Id, null, this.httpOptions);
}
///////////////

CreateComplainant(InvDoc_Id, Investigation) {
  return this.http.post(this.rootUrl + '/api/Investigation/CreateComplainant/' + InvDoc_Id, Investigation, this.httpOptions);
}
GetComplainantStatement(InvDoc_Id: any) {
  return this.http.get(this.rootUrl + '/api/Investigation/GetComplainantStatement/' + InvDoc_Id, this.httpOptions);
}
DeleteComplainantStatemant(Id) {
  return this.http.put(this.rootUrl + '/api/Investigation/DeleteComplainantStatemant/' + Id, null, this.httpOptions);
}
/////////////////////////////////
CreateWitness(InvDoc_Id, Investigation) {
  return this.http.post(this.rootUrl + '/api/Investigation/CreateWitness/' + InvDoc_Id, Investigation, this.httpOptions);
}
GetWitnessStatement(InvDoc_Id: any) {
  return this.http.get(this.rootUrl + '/api/Investigation/GetWitnessStatement/' + InvDoc_Id, this.httpOptions);
}
DeleteWitnessStatemant(Id) {
  return this.http.put(this.rootUrl + '/api/Investigation/DeleteWitnessStatemant/' + Id, null, this.httpOptions);
}
/////////////////////////////////
CreateCeasedProperty(InvDoc_Id, Investigation) {
  return this.http.post(this.rootUrl + '/api/Investigation/CreateCeasedProperty/' + InvDoc_Id, Investigation, this.httpOptions);
}
GetCeasedPropertyFormat(InvDoc_Id: any) {
  return this.http.get(this.rootUrl + '/api/Investigation/GetCeasedPropertyFormat/' + InvDoc_Id, this.httpOptions);
}
DeleteCeasedPropertyStatemant(Id) {
  return this.http.put(this.rootUrl + '/api/Investigation/DeleteCeasedPropertyStatemant/' + Id, null, this.httpOptions);
}
/////////////////////////////////
CreateInvDocument(InvDoc_Id, Investigation) {
  return this.http.post(this.rootUrl + '/api/Investigation/CreateInvDocument/' + InvDoc_Id, Investigation, this.httpOptions);
}
GetDocumentList(InvDoc_Id: any) {
  return this.http.get(this.rootUrl + '/api/Investigation/GetDocumentList/' + InvDoc_Id, this.httpOptions);
}
DeleteDocumentList(Id) {
  return this.http.put(this.rootUrl + '/api/Investigation/DeleteDocumentList/' + Id, null, this.httpOptions);
}

GetCheckList(InvDoc_Id: any) {
return this.http.get(this.rootUrl + '/api/Investigation/GetCheckList/' + InvDoc_Id, this.httpOptions);
}

CreateCheckList(InvDoc_Id, Investigation) {
return this.http.post(this.rootUrl + '/api/Investigation/CreateCheckList/' + InvDoc_Id, Investigation, this.httpOptions);
}
UpdateInvestigation(InvDoc_Id, Investigation) {
return this.http.put(this.rootUrl + '/api/Investigation/UpdateInvestigation/' + InvDoc_Id, Investigation, this.httpOptions);
}


//p Enquiry details


GetCompForTheIdCp(Comp_id: any) {
  return this.http.get(this.rootUrl + '/api/PrEnqDetails/' + Comp_id, this.httpOptions);
}
UpdateEnqDetails(udm,PrEnq_Id) {
  return this.http.put(this.rootUrl + '/api/PrEnqDetails/UpdateEnqDetails/'+PrEnq_Id, udm, this.httpOptions);
}
PostReleatedDoc(PrEnq_Id,r) {
  return this.http.post(this.rootUrl + '/api/PrEnqDetails/CreateReleatedDoc/'+PrEnq_Id, r, this.httpOptions);
}
GetAllComplaintPaginations(itemsPerPage: number, pageNo: number) {
  return this.http.get(this.rootUrl + '/api/PrEnqDetails/GetAllComplaintDetailsCp/' + itemsPerPage + "/" + pageNo+ "/", this.httpOptions);
}

SearchComplaints(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
  return this.http.get(this.rootUrl + '/api/PrEnqDetails/SearchCp/' + itemsPerPage + "/" + pageNo + "/" + searchCriteria + "/" + searchText + "/",this.httpOptions);
}

//Final Repost
GetAllFirDetailsF(itemsPerPage: number, pageNo: number) {
  return this.http.get(this.rootUrl + '/Api/FinalReport/GetAllFirDetailsF/' + itemsPerPage + "/" + pageNo+ "/", this.httpOptions);
}
SearchFirDetailsF(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
  return this.http.get(this.rootUrl + '/Api/FinalReport/SearchF/' + searchCriteria + "/" + searchText + "/" + itemsPerPage + "/" + pageNo+ "/", this.httpOptions);
}
GetFirForTheIdF(Fir_id: any) {
  return this.http.get(this.rootUrl + '/api/FinalReport/' + Fir_id, this.httpOptions);
}
uploadImage1c(data) {
  return this.http.post(this.rootUrl + '/api/FinalReport/image1', data);
}
uploadImage2c(data) {
  return this.http.post(this.rootUrl + '/api/FinalReport/image1', data);
}
uploadImage3c(data) {
  return this.http.post(this.rootUrl + '/api/FinalReport/image1', data);
}
uploadImage4c(data) {
  return this.http.post(this.rootUrl + '/api/FinalReport/image1', data);
}
uploadImage5c(data) {
  return this.http.post(this.rootUrl + '/api/FinalReport/image1', data);
}

CreateChargeSheet(udm,Fir_id,FinalReportId) {
  return this.http.post(this.rootUrl + '/api/FinalReport/CreateChargeSheet/'+Fir_id +"/"+FinalReportId, udm, this.httpOptions);
}
CreateEvidence(udm,Fir_id,FinalReportId) {
  return this.http.post(this.rootUrl + '/api/FinalReport/CreateEvbidence/'+Fir_id +"/"+FinalReportId, udm, this.httpOptions);
}
CreateUndetect(udm,Fir_id,FinalReportId) {
  return this.http.post(this.rootUrl + '/api/FinalReport/CreateUndetect/'+Fir_id +"/"+FinalReportId, udm, this.httpOptions);
}
CreateTransfer(udm,Fir_id,FinalReportId) {
  return this.http.post(this.rootUrl + '/api/FinalReport/CreateTransfer/'+Fir_id +"/"+FinalReportId, udm, this.httpOptions);
}
// GetFirForTheIdForChargesheet(Fir_id: any) {
//   return this.http.get(this.rootUrl + '/api/FinalReport/' + Fir_id, this.httpOptions);
// }
GetFirForTheIdForChargesheet(Fir_id) {
  return this.http.get(this.rootUrl + '/api/FinalReport/GetByIdChargeSheet/' +Fir_id , this.httpOptions);
}
GetFirForTheIdForEvidence(Fir_id) {
  return this.http.get(this.rootUrl + '/api/FinalReport/GetByIdEvidence/' +Fir_id , this.httpOptions);
}
GetFirForTheIdForUndetect(Fir_id) {
  return this.http.get(this.rootUrl + '/api/FinalReport/GetByIdUndetect/' +Fir_id , this.httpOptions);
}
GetFirForTheIdForTransfer(Fir_id) {
  return this.http.get(this.rootUrl + '/api/FinalReport/GetByIdTransfer/' +Fir_id , this.httpOptions);
}

//Relateddoc delete
RelatedDocDetailsdelete(Rdocument_Id) {
  return this.http.put(this.rootUrl + '/api/PrEnqDetails/RelatedDocDelete/' + Rdocument_Id, null, this.httpOptions);
}
}



// WEBPACK FOOTER //
// ./src/app/shared/user.service.ts